import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import theme from 'site-react/theme';

const wrapperStyle = css`
  padding: 16px 24px;
  display: inline-block;
  width: 100%;
  height: 48px;
  background-color: ${theme.colors.brandPrimary};
`;

/**
 * A drawer header.
 * @param {any} props
 */
const DrawerHeader = ({ children }) => (
  <div className={wrapperStyle}>{children}</div>
);

DrawerHeader.defaultProps = {
  children: null,
};

DrawerHeader.propTypes = {
  children: PropTypes.node,
};

export default DrawerHeader;
